<template>
  <!-- 
  options可配置，size文件大小
  getOssRes父组件触发获取返回结果
 -->
  <div>
    <div class="picture" v-if="options.optionbtn">
      <div>
        <Upload class="uplod1" action="" :before-upload="beforeUpload">
          <Button class="btn">浏览</Button>
        </Upload>
      </div>
    </div>

    <div class="picture1" v-if="options.optionbtn1">
      <Upload class="uplod2" action="" :before-upload="beforeUpload">
        <div class="logo">
          <Icon type="ios-add" size="30" />
        </div>
      </Upload>
    </div>
     <div class="picture8" v-if="options.optionbtn8">
      <Upload class="uplod2" :disabled="forbid" action="" :before-upload="beforeUpload">
        <div class="logo">
          <Icon type="ios-add" size="30" />
        </div>
      </Upload>
    </div>
     <div class="pictureClaim" v-if="options.pictureClaim">
      <Upload class="uplod2" :disabled="forbid" action="" :before-upload="beforeUpload">
        <div class="logo">
          <Icon type="ios-add" size="30" />
        </div>
      </Upload>
    </div>
    <!-- 店铺上传 -->
    <Upload v-if="options.logoTop" action="" :before-upload="beforeUpload">
      <Button type="error">上传图片</Button>
    </Upload>
     <!-- 店铺顶部图片上传-->
    <div v-if="options.headpiece" class="y">
      <Upload
        action=""
        :before-upload="beforeUpload"
        class="upload"
        style="display: inline-block; width: 100%; height: 100px;margin-left: 0px;"
      >
        <div style="width: 100%; height: 100px">
          <Icon type="md-add" size="24" color="#C1C1C1"></Icon>
          <p class="icon-p">尺寸1200*100</p>
        </div>
      </Upload>
    </div>
    <!-- 店铺照片 -->
    <div v-if="options.imgs">
      <Upload
        action=""
        :before-upload="beforeUpload"
        class="upload"
        style="display: inline-block; width: 100px; height: 100px"
      >
        <div>
          <Icon type="md-add" size="24" color="#C1C1C1"></Icon>
          <p class="icon-p">尺寸100*100</p>
        </div>
      </Upload>
    </div>
    <!-- 编辑商品 -->
    <div class="picture1 edit" v-if="options.edit">
      <Upload class="uplod1" action="" :before-upload="beforeUpload">
        <div class="logo">
          <Icon type="ios-add" size="30" />
        </div>
      </Upload>
    </div>
  <!-- 编辑头像 -->
    <div class="picture tips" v-if="options.tips">
      <Upload class="uplod1" action="" :before-upload="beforeUpload">
        <Button>点击编辑头像</Button>
      </Upload>
    </div>

    <!-- 注册 -->
    <div v-if="options.regiter1">
      <upload class="avatar-uploader" action="" :before-upload="beforeUpload">
        <div class="iconbox3">
          <Icon type="md-add" size="24" /> <i>请提供法人身份证正面</i>
        </div></upload
      >
    </div>
    <div v-if="options.regiter2">
      <upload class="avatar-uploader" action="" :before-upload="beforeUpload">
        <div class="iconbox3">
          <Icon type="md-add" size="24" /> <i>请提供法人身份证反面</i>
        </div></upload
      >
    </div>
    <div v-if="options.regiter3">
      <upload class="avatar-uploader" action="" :before-upload="beforeUpload">
        <div class="iconbox3">
          <Icon type="md-add" size="24" /> <i>营业执照</i>
        </div></upload
      >
    </div>
    <div v-if="options.regiter4">
      <upload class="avatar-uploader" action="" :before-upload="beforeUpload">
        <div class="iconbox3">
          <Icon type="md-add" size="24" /> <i>门头照</i>
        </div></upload
      >
    </div>
  </div>
</template>

<script>
import OSS from 'ali-oss'
import { getAliOssKey } from './index'
export default {
  data() {
    this.randomArr = [
      '0',
      '1',
      '2',
      '3',
      '4',
      '5',
      '6',
      '7',
      '8',
      '9',
      'a',
      'b',
      'c',
      'd',
      'e',
      'f',
      'g',
      'h',
      'i',
      'j',
      'k',
      'l',
      'm',
      'n',
      'o',
      'p',
      'q',
      'r',
      's',
      't',
      'u',
      'v',
      'w',
      'x',
      'y',
      'z',
      'A',
      'B',
      'C',
      'D',
      'E',
      'F',
      'G',
      'H',
      'I',
      'J',
      'K',
      'L',
      'M',
      'N',
      'O',
      'P',
      'Q',
      'R',
      'S',
      'T',
      'U',
      'V',
      'W',
      'X',
      'Y',
      'Z'
    ]
    return {}
  },
  props: {
    forbid:Boolean,
    options: {
      type: Object,
      default: () => {
        return {
          size: 2, // 大小
          optionbtn: true, // 按钮
          optionbtn1: true, // 图片
          logoTop: true, // 店铺按钮
          fileType: [],
          edit: false,
          regiter1: true,
          regiter2: true,
          regiter3: true,
          regiter4: true,
          tips: false,
          headpiece:true,//店铺顶部图片上传
        }
      }
    }
  },
  // mounted() {
  //   // console.log(this.options)
  // },
  methods: {
    // 上传文件名 建议为：filePre+"/"+"yyyy/mm/dd/"+时间戳_随机码+“文件后缀”
    handleStr(filePre, name) {
      let str = ''
      let index = 0
      let date = new Date()
      const range = Math.round(Math.random() * 4) + 6
      for (let i = 0; i < range; i++) {
        index = Math.round(Math.random() * this.randomArr.length - 1)
        str += this.randomArr[index]
      }
      let extension = name.split('.').pop()
      return (
        filePre +
        '/' +
        date.toLocaleDateString() +
        '/' +
        +date +
        '_' +
        str +
        '.' +
        extension
      )
    },
    beforeUpload(file) {
      this.uploadOSS(file)
      return false
    },

    async uploadOSS(file) {
      const { size } = file
      let name1 = file.name.split('.').pop()
      name1 = name1.toLowerCase()
      console.log(name1)
      if (this.options.size < size / 1024 / 1024) {
        return this.$Message.error('文件大小超出' + this.options.size + 'M!')
      }
      if (this.options.fileType.includes(name1)) {
        console.log('成功')
      } else {
        this.$Message.error('格式错误')
        return false
      }

      const { data } = await getAliOssKey()
      // const { data } = await getAliOssKey()
      // const data = JSON.parse(localStorage.getItem('wlj'))
      let client = new OSS({
        region: data.regionId,
        accessKeyId: data.accessKeyId,
        accessKeySecret: data.accessKeySecret,
        stsToken: data.securityToken,
        bucket: data.bucket,
        endpoint: data.hostPre,
        secure: true,
        cname: true
        // ...data
      })
      const res = await client.put(
        this.handleStr(data.filePre, file.name),
        file
      )
      this.$emit('getOssRes', res, file.name)
    }
  }
}
</script>

<style lang="less" scoped>
.picture {
  display: flex;
  justify-content: center;
  align-items: center;
}
.btn {
  width: 80px;
  height: 32px;
}
.picture1 {
  width: 80px;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #d8d8d8;
  margin: 3px 8px;
}
.picture8{
  width: 80px;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #d8d8d8;
  /deep/.ivu-upload-select{
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .logo{
    width: 30px;
    height: 30px;
    margin-top: 3px;
  }
}
.pictureClaim{
  width: 100px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #d8d8d8;
  cursor: pointer;
  /deep/.ivu-upload-select{
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .logo{
    width: 30px;
    height: 30px;
    margin-top: 3px;
  }
}
.upload {
  margin-left: 16px;
  border: 1px dashed #c1c1c1;
  cursor: pointer;
  div {
    width: 100px;
    height: 100px;
    display: flex;
    text-align: center;
    flex-flow: column;
    .ivu-icon-md-add {
      padding-top: 37px;
    }
    // line-height: 100px;
    .icon-p {
      font-size: 14px;
      color: #c2c2c2;
      cursor: pointer;
      padding-top: 10px;
    }
  }
}
.uplod2 {
  /deep/.ivu-upload {
    width: 80px;
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.edit {
  width: 74px;
  height: 74px;
  cursor: pointer;
}
.tips {
  position: absolute;
  left: 26%;
  top: 46%;
  .ivu-btn {
    background-color: transparent;
    border: transparent;
    color: transparent;
    // color: #000;
  }

  .ivu-btn:focus {
    border: transparent;
    box-shadow: none;
  }
  .ivu-btn:hover,
  .ivu-btn:active {
    color: #3f3232;
    border: #fff;
  }
}
.avatar-uploader {
  text-align: center;
  // float: left;
  border: 1px dashed #e2e2e2;
  border-radius: 6px;
  cursor: pointer;
  // overflow: hidden;
  width: 150px;
  height: 100px;
  // line-height: 100px;
  // background-color: #f2f2f2;
  margin: 12px 5px 5px 5px;
  border-radius: 2px;
  .iconbox3 {
    color: #c1c1c1;
    display: flex;
    flex-flow: column;
    width: 150px;
    height: 100px;
    .ivu-icon-md-add {
      color: #c1c1c1;
      padding-top: 24px;
    }
  }
}
// display: inline-block; width: 100%; border: 1px solid red; height: 100px;
/* /deep/ .span-bor[data-v-92c8a14e] {
    margin-top: 10px;
    height: 100px;
    width: 100%;
    border: 1px solid #fff;
}
/deep/ .span-bor div[data-v-8cdf1dec]{
   display: inline-block;
   width: 100%; 
   height: 100px;
} 
/deep/ .upload[data-v-8cdf1dec] {
    margin-left: 16px;
    border: 1px dashed #c1c1c1;
    width: 100%;
    height: 100px;
    cursor: pointer;
}*/
.span-bor div{
   display: inline-block;
   width: 100%; 
   height: 100px;
}
.y /deep/.ivu-upload-select {
    display: inline-block;
    margin-left: 45%;
}
</style>
</style>
